import { Eye } from "lucide-react";
import type { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { formatDateTime } from "./commissionEditQueue-formatters";
import type { RequestContext } from "./commissionEditQueue.types";
import { CommissionEditStatusBadge } from "./components/CommissionEditStatusBadge";

export function createCommissionEditQueueColumns(
  onSelect: (context: RequestContext) => void,
): ColumnDef<RequestContext, any>[] {
  return [
    {
      id: "request",
      header: "Demande",
      cell: ({ row }) => {
        const context = row.original;
        return (
          <div>
            <p className="text-[12px] font-semibold text-foreground">
              {context.typeLabel ?? context.transaction?.type ?? "Commission"} #
              {context.request.commissionTransactionId}
            </p>
            <p className="mt-0.5 text-[10.5px] text-muted-foreground">
              Demandée le {formatDateTime(context.request.createdAt)}
            </p>
          </div>
        );
      },
    },
    {
      id: "requester",
      header: "Demandeur",
      cell: ({ row }) => (
        <span className="text-[12px] text-body">
          {row.original.requester?.fullName ?? `Agent #${row.original.request.requestedBy}`}
        </span>
      ),
    },
    {
      id: "status",
      header: "Statut",
      cell: ({ row }) => <CommissionEditStatusBadge status={row.original.request.status} />,
    },
    {
      id: "changes",
      header: "Champs",
      meta: { align: "right" },
      cell: ({ row }) => (
        <span className="text-[12px] tabular-nums text-body">
          {Object.keys(row.original.request.proposedChanges).length}
        </span>
      ),
    },
    {
      id: "reviewedAt",
      header: "Révision",
      cell: ({ row }) => (
        <span className="text-[12px] text-muted-foreground">
          {row.original.request.status === "pending"
            ? "Non révisée"
            : formatDateTime(row.original.request.reviewedAt)}
        </span>
      ),
    },
    {
      id: "actions",
      header: "Actions",
      meta: { align: "right" },
      cell: ({ row }) => (
        <Button
          variant="ghost"
          size="sm"
          onClick={(event) => {
            event.stopPropagation();
            onSelect(row.original);
          }}
        >
          <Eye size={13} /> Détail
        </Button>
      ),
    },
  ];
}
